/** @format */

import {
  ContactWidget,
  ExtranetWidget,
  EventsWidget,
  MultiVideosWidget,
  MagazineWidget,
  NewsWidget,
  LinkWidget,
  InfoWidget,
  ShopWidget,
  CardMultiLink,
  AcademyWidget
} from './cards';
import { KnowledgeBaseWidget } from './cards/knowledgeBase';
import { InformationWidget } from './information';
import { HeroWidget } from './hero';
import { ShopOrdersWidget } from './shopOrders';
import { WidgetGa4ClickTracker } from './WidgetGa4ClickTracker';
import { getAppLanguage } from 'src/utils/locale';
import type { GridBreakpoint, ResponsiveLayouts, Widget } from 'src/types/widget';

type GetWidgetProps = {
  data?: Widget | null;
  onSizeChange?: (...args: unknown[]) => void;
  globalLayouts?: ResponsiveLayouts | Record<string, unknown>;
  currentBreakPoint?: GridBreakpoint | string | null;
};

const GetWidget = ({ data, onSizeChange, globalLayouts, currentBreakPoint }: GetWidgetProps) => {
  const appLanguage = getAppLanguage();

  const handleWidgetType = (widgetData: Widget) => {
    switch (widgetData.type) {
      case 'contact': //can be whatever this for testing
        return <ContactWidget data={widgetData} />;
      case 'video': //can be whatever this for testing
        return <MultiVideosWidget data={widgetData} />;
      case 'multi_link':
        return <CardMultiLink data={widgetData} lang={appLanguage} />;
      case 'extranet':
        return <ExtranetWidget data={widgetData} />;
      case 'event':
      case 'events':
        return <EventsWidget data={widgetData} />;
      case 'magazine':
        return <MagazineWidget data={widgetData} />;
      case 'news':
        return <NewsWidget data={widgetData} />;
      case 'link':
        return <LinkWidget data={widgetData} />;
      case 'info':
        return <InfoWidget data={widgetData} />;
      case 'shop':
        return <ShopWidget data={widgetData} />;
      case 'shop_orders':
        return <ShopOrdersWidget data={widgetData} />;
      case 'academy':
      case 'academy_training':
        return <AcademyWidget data={widgetData} />;
      case 'knowledge_base':
        return <KnowledgeBaseWidget data={widgetData} />;
      case 'information':
        return (
          <InformationWidget
            data={widgetData}
            onSizeChange={onSizeChange}
            globalLayouts={globalLayouts}
            currentBreakPoint={currentBreakPoint}
          />
        );
      case 'hero':
        return <HeroWidget data={widgetData} />;
      case 'product_data':
        return <ExtranetWidget data={widgetData} />;
      default:
        return 'No type widget match!'; // when not found that widget *can be whatever
    }
  };

  if (!data) {
    return null;
  }

  const widget = handleWidgetType(data);

  if (data.type === 'hero') {
    return widget;
  }

  return <WidgetGa4ClickTracker data={data}>{widget}</WidgetGa4ClickTracker>;
};

export { GetWidget };
